import { utils } from '@sfaas/util';
import client from '@/api/client';
import { BASE_URL } from '@/constants';

export default {
	getPlants: () => {
		return client
			.get(`${BASE_URL}/cc/v1/plant`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	getCommCodes: param => {
		return client
			.get(`${BASE_URL}/cc/v1/plants/${param.plantCd}/commonCodes?commCdType=${param.codeType}`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	getDicMsgManagements: ({ searchParams, currentPage, pageUnit }) => {
		let queryStr = '';
		if (
			searchParams.msgKey !== undefined ||
			searchParams.msgText !== undefined ||
			searchParams.msgType !== undefined ||
			searchParams.msgLoc !== undefined
		) {
			queryStr = utils.$sf_objectToQueryString({
				msgKey: searchParams.msgKey,
				msgText: searchParams.msgText,
				msgType: searchParams.msgType,
				msgLoc: searchParams.msgLoc,
				currentPage,
				pageUnit
			});
		}
		return client
			.get(`${BASE_URL}/message/v1/plants/${searchParams.plantCd}/messages` + queryStr)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	postDicMsgManagement: param => {
		return client
			.post(`${BASE_URL}/message/v1/status/${param.status}/plants/${param.plantCd}/messages`, param.data)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	}
};
